// extracted by mini-css-extract-plugin
export default {"leadingVisual":"IssueTypePickerItemLeadingVisual-module__leadingVisual--pvUWN","issueTypeColorIndicator":"IssueTypePickerItemLeadingVisual-module__issueTypeColorIndicator--knRNR"};